import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      [theme.fn.largerThan('sm')]: {
        paddingLeft: 48,
        paddingRight: 48,
      },
    },
  }
})
